var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('sky-upload',_vm._g(_vm._b({ref:"upload",attrs:{"value":_vm.value},scopedSlots:_vm._u([{key:"filePopperContent",fn:function(scope){return _vm._t("filePopperContent",null,{"file":scope.file})}}],null,true)},'sky-upload',_vm.$attrs,false),_vm.$listeners)),_c('div',{staticClass:"notice"},[_vm._v(_vm._s(_vm.notice))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }